import { format, parseISO } from "date-fns";

import { formatCurrency } from "../utils/FormatCurrency";
import { colunaBoletoBody} from "./ColumnBody";


export const criaColunasTaxas =       
    ([
        {
          field: "cobranca_descricao",
          style: {fontFamily:'Branding-Regular, serif'},
          header: "Descrição",
        },      
        {
          field: "valor_original",
          style: {fontFamily:'Branding-Regular, serif'},
          header: "Valor",
          body: (rowData) => formatCurrency(rowData.valor_original),
        },
        {
          field: "vencimento",
          style: {fontFamily:'Branding-Regular, serif'},
          header: "Vencimento",
        //  body: (rowData) => format((rowData),'dd/MM/yyyy')
        },
      ])

export const criaColunasNegociadas = (
  [
    {
      field: "cobranca_create",
      header: "Data Criação",
      style: {fontFamily:'Branding-Regular, serif'},
      body: (rowData) => format(new Date(rowData.cobranca_create),'dd/MM/yyyy'),
    },
    {
      field: "cobranca_valor",
      header: "Valor",
      body: (rowData) => formatCurrency(rowData.cobranca_total_pagamento),
      style: {fontFamily:'Branding-Regular, serif'}
    },
    {
      field: "data_vencimento_primeiro_boleto",
      header: "Vencimento",
      body: (rowData) => format(parseISO(rowData.data_vencimento_primeiro_boleto),"dd/MM/yyyy"),
      style: {fontFamily:'Branding-Regular, serif'}
    },

    // {
    //   field: "cobranca_descricao",
    //   header: "Baixar Boleto",
    //   style: {textAlign: "center"},
    //   body: (rowData) => {return (
    //   <a href={rowData.boletos[0].boleto_link} target="_blank" rel="noopener noreferrer">
    //     <Button icon="pi pi-download" className="p-button-rounded boletoButton"></Button>
    //   </a>)}
    // },
    
    {
      field: "data_vencimento_primeiro_boleto",
      header: "Boletos",
      style: {textAlign: "center",fontFamily:'Branding-Regular, serif'},
      body: (rowData) => colunaBoletoBody(rowData.boletos)
    },
  ]
)
